export class RecentlyViewed extends HTMLElement {
    constructor() {
        super();

        this._selectors = {
            recentProducts: "[js-recent-products]",
            carousel: "[js-carousel]",
        };
    }

    connectedCallback() {
        this.carousel = this.querySelector(this._selectors.carousel);
        this._initRecentProducts();
    }

    _reInitCarousel() {
        if (this.carousel.classList.contains("swiper-initialized")) {
            this.carousel.swiper.update();
            this.carousel.swiper.updateProgress();
            this.carousel.swiper.updateSize();
            this.carousel.swiper.updateSlides();
        }
    }

    async _initRecentProducts() {
        const recentProductsContainer = document.querySelector(
            "[js-recent-products]",
        );
        const _recentProductsArray = [];

        // Convert localStorage data into object
        const productData = JSON.parse(localStorage.getItem("recently_viewed"));
        if (!productData) return;

        // Get product handles
        const handlesArr = [];
        for (const product of productData) {
            handlesArr.push(product.handle);
        }

        // Fetch URLs and update HTML
        for (const handle of handlesArr) {
            await fetch(`/products/${handle}/?view=product-card`)
                .then((response) => {
                    return response.text();
                })
                .then((html) => {
                    const parsedHTML = new DOMParser().parseFromString(
                        html,
                        "text/html",
                    );
                    const productCardCopy = parsedHTML.querySelector(
                        "[js-product-card-copy]",
                    ).innerHTML;
                    const productCardWrapper = `<div class="swiper-slide" js-carousel-slide>${productCardCopy}</div>`;

                    if (window.location.href.indexOf(handle) === -1) {
                        recentProductsContainer.insertAdjacentHTML(
                            "beforeend",
                            productCardWrapper,
                        );
                    }
                });
        }

        // Show container and reinit carousel
        if (
            recentProductsContainer.querySelectorAll(".product-card").length > 0
        ) {
            this.classList.remove("hidden");
            this.classList.add("block");
            this._reInitCarousel();
        }
    }
}
